import axios from '@/utilities/axios-global'

export function GET_INTERIM_SCHEDULE_REQUEST(context, id) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + '/interimrequests/' + id).then(response => {
      context.commit('SET_INTERIM_SCHEDULE_REQUEST', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function POST_INTERIM_SCHEDULE_REQUEST(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/interimrequests`, payload).then(response => {
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function PUT_INTERIM_SCHEDULE_REQUEST(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + `/interimrequests/${payload.requestId}`, payload.interimRequest).then(response => {
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export default {
  GET_INTERIM_SCHEDULE_REQUEST,
  POST_INTERIM_SCHEDULE_REQUEST,
  PUT_INTERIM_SCHEDULE_REQUEST
}
